export default function setup() {
    const initChoices = (selector, placeholder) => {
        const el = document.querySelector(selector);
        if (!el) return null;

        return new Choices(el, {
            placeholder: true,
            placeholderValue: placeholder,
            shouldSort: false,
            searchEnabled: false,
            itemSelectText: '',
            loadingText: 'Loading...',
            noResultsText: 'No results found',
            noChoicesText: 'No options available',
            classNames: {
                containerInner: 'choices__inner',
                input: 'choices__input',
                listDropdown: 'choices__list--dropdown'
            }
        });
    };

    const initChoicesMultiple = (selector, placeholder) => {
        const el = document.querySelector(selector);
        if (!el) return null;

        return new Choices(el, {
            placeholder: true,
            placeholderValue: placeholder,
            shouldSort: false,
            searchEnabled: false,
            itemSelectText: '',
            loadingText: 'Loading...',
            noResultsText: 'No results found',
            noChoicesText: 'No options available',
            removeItemButton: true,
            classNames: {
                containerInner: 'choices__inner',
                input: 'choices__input',
                listDropdown: 'choices__list--dropdown'
            }
        });
    };

    const choices = {
        fromYear: initChoices('.js-choice-from-year', 'Select From Year'),
        toYear: initChoices('.js-choice-to-year', 'Select To Year'),
        makes: initChoices('.js-choice-makes', 'Select Make'),
        models: initChoices('.js-choice-models', 'Select Model'),
        fromPrice: initChoices('.js-choice-from-price', 'Select From Price'),
        toPrice: initChoices('.js-choice-to-price', 'Select To Price'),
        mileage: initChoices('.js-choice-mileage', 'Select Distance'),
        states: initChoicesMultiple('.js-choice-states','Location State')
    };

    // Generate years array (1990 to current year)
    const generateYears = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear; year >= 1990; year--) {
            years.push({
                value: year.toString(),
                label: year.toString()
            });
        }
        return years;
    };

    // Set year dropdown options
    const setYearDropdowns = () => {
        const years = generateYears();

        if (choices.fromYear) {
            choices.fromYear.setChoices([
                { value: '', label: 'Select From Year', placeholder: true }
            ].concat(years), 'value', 'label', true);
        }

        if (choices.toYear) {
            choices.toYear.setChoices([
                { value: '', label: 'Select To Year', placeholder: true }
            ].concat(years), 'value', 'label', true);
        }
    };

    const handleMakeChange = () => {
        const makesSelect = document.querySelector('.js-choice-makes');
        if (!makesSelect || !choices.models) return;

        let controller = null;

        makesSelect.addEventListener('change', async (e) => {
            const makeId = e.detail.value;
            const modelsContainer = document.querySelector('.js-choice-models').closest('.choices');

            // Clear previous state
            choices.models.removeActiveItems();
            choices.models.clearStore();
            modelsContainer.classList.add('choices--loading');

            // Abort previous request
            if (controller) controller.abort();

            try {
                controller = new AbortController();
                const response = await fetch(`/boatssearch/getmodels?itemTypeId=${makeId}`, {
                    signal: controller.signal
                });

                const data = await response.json();
                modelsContainer.classList.remove('choices--loading');

                // Format model options without placeholder
                const modelOptions = data.map(model => ({
                    value: model.systemFields.contentItemGUID,
                    label: model.model,
                    selected: false,
                    disabled: false
                }));

                // Clear existing choices first
                choices.models.clearChoices();

                if (modelOptions.length > 0) {
                    // Add new choices and reset to placeholder
                    choices.models.setChoices(modelOptions, 'value', 'label', true);
                    choices.models.setChoiceByValue(''); // Reset to placeholder
                } else {
                    choices.models.setChoices([{
                        value: '',
                        label: 'No models available',
                        disabled: true
                    }], 'value', 'label', true);
                }
            } catch (error) {
                if (error.name !== 'AbortError') {
                    modelsContainer.classList.remove('choices--loading');
                    choices.models.setChoices([{
                        value: '',
                        label: 'Error loading models',
                        disabled: true
                    }], 'value', 'label', true);
                }
            }
        });
    };
    setYearDropdowns();
    handleMakeChange();
}